import { configActions } from 'core/Config';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    Container,
    ExpandButton,
    FormGroup,
    Input,
    Loader,
    Separator
} from 'mol-ui';
import React, { useEffect, useMemo } from 'react';
import {
    useArray,
    useDispatch,
    useInput,
    useSelector
} from 'hooks';

const BackendConfiguration = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        backendConfiguration,
        platformConfigurationLoading,
        platformConfigurationProcessing
    } = useSelector('config');

    const [currentConfig, setCurrentConfig, { replaceValues: replaceConfigValues }] = useArray([], { type: 'object' });
    const [currentProperties, setCurrentProperties, { replaceValues: replacePropertiesValues }] = useArray([], { type: 'object' });
    const [filterInput, filter] = useInput('');

    const filteredConfig = useMemo(() => currentConfig.filter(({ name }) => name.toLowerCase().includes(filter.toLowerCase())), [currentConfig, filter]);
    const filteredProperties = useMemo(() => currentProperties.filter(({ name }) => name.toLowerCase().includes(filter.toLowerCase())), [currentProperties, filter]);

    useEffect(() => {
        dispatch(configActions.getBackendConfiguration());
    }, []);

    useEffect(() => {
        const { account_properties = [], configurations = [] } = backendConfiguration;
        setCurrentConfig(configurations);
        setCurrentProperties(account_properties);
    }, [backendConfiguration, setCurrentConfig, setCurrentProperties]);

    const onSubmit = () => {
        dispatch(configActions.updateBackendConfiguration({
            account_properties: currentProperties,
            configuration: currentConfig
        }));
    };

    return (
        <Container height="100%" padding="10px">
            {
                platformConfigurationLoading && <Loader active />
            }
            {
                !platformConfigurationLoading &&
                <>
                    <FormGroup label={ t('Buscar configuración') } margin="10px 0px 0px 0px" width="100%">
                        <Input { ...filterInput } />
                    </FormGroup>
                    <Separator size="3px" />
                    <Container flex="1" overflowY="auto">
                        {
                            filteredConfig.map(({
                                comment,
                                name,
                                value
                            }) => (
                                <FormGroup comment={ comment } key={ name } label={ name } margin="10px 0px 0px 0px" width="100%">
                                    <Input
                                        disabled={ platformConfigurationProcessing }
                                        margin="0px"
                                        value={ value ?? '' }
                                        onChange={ value => replaceConfigValues({ value }, 'name', name) }
                                    />
                                </FormGroup>
                            ))
                        }
                        <Separator size="3px" />
                        {
                            filteredProperties.map(({
                                comment,
                                name,
                                value
                            }) => (
                                <FormGroup comment={ comment } key={ name } label={ name } margin="10px 0px 0px 0px" width="100%">
                                    <Input
                                        disabled={ platformConfigurationProcessing }
                                        margin="0px"
                                        value={ value ?? '' }
                                        onChange={ value => replacePropertiesValues({ value }, 'name', name) }
                                    />
                                </FormGroup>
                            ))
                        }
                    </Container>
                    <ButtonFooter margin="20px 0px 0px 0px">
                        <ExpandButton
                            caption={ t('Guardar') }
                            loading={ platformConfigurationProcessing }
                            size={ 100 }
                            onClick={ onSubmit }
                        />
                    </ButtonFooter>
                </>
            }
        </Container>
    );
};

export default BackendConfiguration;
